<template>
  <div>
    <v-card class="pa-2" flat>
      <v-btn small @click="$router.back()" color="info" rounded outlined>
        <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras 
      </v-btn>
      <v-card-text>
        <v-container fluid v-if="user" class="pa-0 ma-0">
          <p class="ma-0"><b>Sede:</b> {{ this.$store.state.CARGO.sede.nombre }}</p>
        </v-container>
        <div class="row">
          <div class="col-sm-6">
            <input v-model.trim="busqueda.fecha_ini" class="xinput" type="date" />
            <input v-model.trim="busqueda.fecha_fin" class="xinput" type="date" />
            <label class="mr-0"> <input type="checkbox" v-model="confirmado" /> confirmados </label>
            <label>
              <input
                type="checkbox"
                v-model="allsedes"
                v-show="isnacional"
                title="Solo se listaran las sedes de ESAM" />
              todas las sedes.
            </label>
          </div>
          <div class="col-sm-2">
            <Usuarios ref="user1" :current="false" :model="asesor" :xholder="'Asesor...'" />
          </div>
          <div class="col-sm-2">
            <Usuarios ref="user2" :current="false" :model="emisor" :xholder="'Emisor...'" />
          </div>
          <div class="col-sm-1">
            <button class="btn btn-sm btn-azul oulined white--text" @click="listarrecibos()">buscar</button>
          </div>
        </div>

        <div class="text-center">
          <div style="display: inline-block" v-show="loading" class="loader"></div>
        </div>

        <div class="table-responsive" style="height: 72vh;overflow-y: scroll;position: relative;">
          <table ref="table" class="table table-condensed">
            <thead style="background: #196391 !important;z-index: 50;" class="tablii">
              <tr style="color: #ffffff;background: #196391 !important;top:0;z-index: 50;position: sticky;" class="manito">
                <th>Nro.</th>
                <th>FECHA REG.</th>
                <!-- en la vista no se ve, pero en el excel de descarga si -->
                <th v-show="false">NRO_CUOTA</th>
                <th v-if="unidad_negocio == 1 || isbenitojuarez">MATRÍCULA</th>
                <th v-if="unidad_negocio == 1 || isbenitojuarez">COLEGIATURA</th>
                <th v-if="unidad_negocio == 1 || isbenitojuarez">CURSO</th>
                <th v-if="unidad_negocio == 1 || isbenitojuarez">TRÁMITE DE CERTIFICACIÓN</th>
                <th v-if="unidad_negocio == 1">OTROS INGRESOS</th>
                <th
                  v-for="(d, indx) in columnas_dinamicas"
                  :key="indx"
                  style="min-width: 120px; max-width: 150px !important; white-space: break-spaces !important">
                  {{ formatcolumnadinac(d) }}
                </th>
                <!-- <th>CANTIDAD</th> -->
                <th>IMPORTE TOTAL</th>
                <th>Nº DE RECIBO</th>
                <th>N° FACTURA</th>
                <th>COD. CONTABILIDAD</th>
                <th>CARNET</th>
                <th>APELLIDOS Y NOMBRES</th>
                <th>TIPO DE PROGRAMA</th>
                <th>NOMBRE</th>
                <th>FORMA DE PAGO</th>
                <th>BANCOS</th>
                <th>N° CUENTA</th>
                <th>TIPO DE CUENTA</th>
                <th>NOMBRE DEL DEPOSITANTE</th>
                <th>N° DE COMPROBANTE</th>
                <th>CARNET DEPOSITANTE</th>
                <th>FECHA DEL PAGO</th>
                <th>EMISOR</th>
                <th>ASESOR</th>
              </tr>
            </thead>
            <tbody class="tabli" style="z-index: 1;">
              <tr v-for="(r, ind) in recibos" :key="ind">
                <td :title="'ID: ' + r.id">{{ ind + 1 }}</td>
                <td>{{ r.fecha }}</td>
                <td v-show="false">{{ obtenerNumeroCuota(r) }}</td>
                <td v-if="unidad_negocio == 1 || isbenitojuarez">{{ r.matricula }}</td>
                <td v-if="unidad_negocio == 1 || isbenitojuarez">{{ r.colegiatura }}</td>
                <td v-if="unidad_negocio == 1 || isbenitojuarez">{{ r.curso }}</td>
                <td v-if="unidad_negocio == 1 || isbenitojuarez">{{ r.tramcertificacion }}</td>
                <td v-if="unidad_negocio == 1">{{ r.otrosingresos }}</td>
                <td v-for="(d, indx) in columnas_dinamicas" :key="indx">{{ r[d] }}</td>
                <!-- <td>{{ r.cantidad }}</td> -->
                <td>{{ r.importetotal }}</td>
                <td>{{ r.recibo }}</td>
                <td>{{ r.factura }}</td>
                <td>{{ r.codigo_programa }}</td>
                <td>{{ r.numero_documento_estudiante }}</td>
                <td>{{ r.estudiante }}</td>
                <td>{{ r.tipoprograma }}</td>
                <td>{{ r.nombreprograma }}</td>
                <td>{{ r.formapago }}</td>
                <td>{{ r.banco }}</td>
                <td>{{ r.nrocuenta }}</td>
                <td>{{ r.tipocuenta }}</td>
                <td>{{ r.depositante }}</td>
                <td>{{ r.numero_comprobante }}</td>
                <td>{{ r.numero_documento_depositante }}</td>
                <td>{{ r.fechadelpago }}</td>
                <td>{{ r.emisor }}</td>
                <td>{{ r.asesor }}</td>
                <td v-show="false">
                  <button
                    class="btn btn-link btn-sm"
                    @click="openDialogDetail(r)"
                    data-toggle="modal"
                    data-target="#modal-recibo">
                    <span class="glyphicon glyphicon-eye-open"></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        

        <download-excel
          v-if="!$store.state.isonlyread && unidad_negocio == 1"
          v-show="recibos.length > 0"
          class="btn btn-info"
          :data="recibos"
          :fields="isbenitojuarez ? json_fieldsbenito : json_fields"
          worksheet="Recibos"
          name="recibos.xls">
          <v-icon class="ma-0" color="white">mdi-download</v-icon> Descargar Datos en excel
        </download-excel>
        <button
          v-else-if="!$store.state.isonlyread"
          :disabled="$store.state.isonlyread"
          v-show="recibos.length > 0"
          class="btn btn-sm btn-azul"
          @click="tableToExcel('table', 'Lorem Table')">
          <span class="glyphicon glyphicon-print"></span> Descargar en formato EXCEL
        </button>
      </v-card-text>

      <show ref="refDetail"></show>
    </v-card>
  </div>
</template>

<style>
  .xtab {
    width: 50px !important;
  }
  .loader {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid blue; /* Blue */
  border-bottom: 4px solid blue;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1.2s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<script>
  import Show from './Show';
  import Usuarios from '@/components/AUsuariosActivos';
  import { getheadersrest } from '@/components/Utils';
  import { similarity } from '@/components/cadenas.js';
  import gql from 'graphql-tag'; 

  export default {
    components: { Show, Usuarios },
    data() {
      return {
        uri: 'data:application/vnd.ms-excel;base64,',
        template:
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format: function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        },
        isbenitojuarez: false,
        unidad_negocio: 1,
        isnacional: false,
        menu_name: process.env.VUE_APP_NAME_MENU,
        api_rest: process.env.VUE_APP_API_REST,
        user: null,
        recibos: [],
        busqueda: { fecha_ini: '', fecha_fin: '' },
        loading: false,
        confirmado: true,
        allsedes: false,
        columnas_dinamicas: [],
        asesor: { idusuario: {} },
        emisor: { idusuario: {} },
        json_fields: {
          FECHA: 'fecha',
          NRO_CUOTA: 'concepto',
          MATRÍCULA: 'matricula',
          COLEGIATURA: 'colegiatura',
          CURSO: 'curso',
          'TRÁMITE DE CERTIFICACIÓN': 'tramcertificacion',
          'OTROS INGRESOS': 'otrosingresos',
          'IMPORTE TOTAL': 'importetotal',
          'Nº DE RECIBO': 'recibo',
          'N° FACTURA': 'factura',
          'COD. CONTABILIDAD': 'codigo_programa',
          CARNET: 'numero_documento_estudiante',
          'APELLIDOS Y NOMBRES': 'estudiante',
          'TIPO DE PROGRAMA': 'tipoprograma',
          NOMBRE: 'nombreprograma',
          'FORMA DE PAGO': 'formapago',
          BANCOS: 'banco',
          'N° CUENTA': 'nrocuenta',
          'TIPO DE CUENTA': 'tipocuenta',
          'NOMBRE DEL DEPOSITANTE': 'depositante',
          'N° DE COMPROBANTE': 'numero_comprobante',
          'CARNET DEPOSITANTE': 'numero_documento_depositante',
          'FECHA DEL PAGO': 'fechadelpago',
          EMISOR: 'emisor',
          ASESOR: 'asesor',
        },
        json_fieldsbenito: {
          FECHA: 'fecha',
          'OTROS INGRESOS': 'otrosingresos',
          'IMPORTE TOTAL': 'importetotal',
          'Nº DE RECIBO': 'recibo',
          'N° FACTURA': 'factura',
          'COD. CONTABILIDAD': 'codigo_programa',
          CARNET: 'numero_documento_estudiante',
          'APELLIDOS Y NOMBRES': 'estudiante',
          'TIPO DE PROGRAMA': 'tipoprograma',
          NOMBRE: 'nombreprograma',
          'FORMA DE PAGO': 'formapago',
          BANCOS: 'banco',
          'N° CUENTA': 'nrocuenta',
          'TIPO DE CUENTA': 'tipocuenta',
          'NOMBRE DEL DEPOSITANTE': 'depositante',
          'N° DE COMPROBANTE': 'numero_comprobante',
          'CARNET DEPOSITANTE': 'numero_documento_depositante',
          'FECHA DEL PAGO': 'fechadelpago',
          EMISOR: 'emisor',
          ASESOR: 'asesor',
        },
        json_meta: [
          [
            {
              key: 'charset',
              value: 'utf-8',
            },
          ],
        ],
      };
    },
    watch: {
      '$store.state.CARGO': function () {
        this.asesor.idusuario = {};
        this.emisor.idusuario = {};
        this.$refs.user1.getDatos();
        this.$refs.user2.getDatos();
        this.listarrecibos();
      },
      '$route.name': function () {
        this.isbenitojuarez = location.href.includes('recibosbenito');
      },
    },
    methods: {
      openDialogDetail(recibo) {
        this.$refs.refDetail.showThisView(recibo);
      },
      paddingceros(num, places) {
        if (num == 0) return '';
        if (!num) return '';
        let res = String(num).padStart(places, '0');
        return res;
      },
      tableToExcel(table, name) {
        if (!table.nodeType) table = this.$refs.table;
        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
        var link = document.createElement('a');
        link.download = 'recibos-cca.xls';
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
      formatcolumnadinac(str) {
        let indice = str.lastIndexOf('-');
        let text = str;
        if (indice > 0) text = text.substring(0, indice);
        return text;
      },
      parsefecha(f) {
        if (!f) return '';
        let fs = []; // yyyy-mm-dd
        if (f.includes(' ')) {
          let ff = f.split(' ');
          fs = ff[0].split('-');
        } else {
          fs = f.split('-');
        }
        return fs[2] + '/' + fs[1] + '/' + fs[0];
      },
      blankiscero(valor) {
        if (!valor) return ''; 
        valor = this.addSeparatorsNF(valor, '.', ',', '.');
        return valor;
      },
      tonumberdecimal(n) {
        n = n.replace(/\./g, '').replace(',', '.');
        return !isNaN(parseFloat(n)) && isFinite(n);
      },
      addSeparatorsNF(nStr, inD, outD, sep) {
        nStr = Number(nStr).toFixed(2);
        nStr += '';
        var dpos = nStr.indexOf(inD);
        var nStrEnd = '';
        if (dpos != -1) {
          nStrEnd = outD + nStr.substring(dpos + 1, nStr.length);
          nStr = nStr.substring(0, dpos);
        }
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(nStr)) {
          nStr = nStr.replace(rgx, '$1' + sep + '$2');
        }
        return nStr + nStrEnd;
      },
      listarrecibos() {
        if (!this.busqueda.fecha_ini || !this.busqueda.fecha_fin) {
          // window.console.log('Ingrese las fechas');
          return;
        }
        const vue = this;
        vue.recibos = [];
        vue.loading = true;
        let fs1 = this.busqueda.fecha_ini.split('-');
        let fs2 = this.busqueda.fecha_fin.split('-');
        let fecha1 = fs1[2] + '/' + fs1[1] + '/' + fs1[0];
        let fecha2 = fs2[2] + '/' + fs2[1] + '/' + fs2[0];

        /*var myHeaders = new Headers(); 
        myHeaders.append("Content-Type", "application/json");*/
        let myHeaders = getheadersrest();
        if (!this.asesor.idusuario) this.asesor.idusuario = {};
        if (!this.emisor.idusuario) this.emisor.idusuario = {};
        let idasesorsel = this.asesor.idusuario.id;
        let idemisorsel = this.emisor.idusuario.id;
        let idsede = this.$store.state.CARGO.idsede;
        this.columnas_dinamicas = [];
        this.unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
        if (this.unidad_negocio == 10) this.unidad_negocio = 1;
        let fil = {
          asesor_id: idasesorsel,
          emisor_id: idemisorsel,
          sede_id: idsede,
          confirmado: this.confirmado,
          fecha_inicio: fecha1,
          fecha_fin: fecha2,
          estado: true,
        };
        if (this.allsedes) delete fil.sede_id;
        if (!idasesorsel) delete fil.asesor_id;
        if (!idemisorsel) delete fil.emisor_id;

        var raw = JSON.stringify(fil);
        // // window.console.log( raw );

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow',
        };

        window.console.log(fil, this.$store.state.CARGO);

        //fetch(this.api_rest+"api/pagos/recibos/buscar", requestOptions)
        fetch(this.api_rest + '/api/pagos/recibos/reporte', requestOptions)
          .then((response) => response.json())
          .then((result) => {
            vue.loading = false;
            window.console.log('RECIBOS:\n', result);
            if (!result) return;
            if (vue.allsedes && vue.unidad_negocio == 1) {
              result = vue.filtrarsoloesam(result);
            }
            // this.listarInscripciones(result[0].inscripcion_id)
            /*let conceptos = [];
            result.forEach((x) => {
              x.detalle.forEach((d) => {
                let ex = conceptos.find((c) => c.concepto_pago_id == d.concepto_pago_id);
                if (!ex) conceptos.push(JSON.parse(JSON.stringify(d)));
              });
            });

            if (result) {
              if (result[0].detalle) {
                let primero = window.Object.assign({}, result[0].detalle[0]);
                for (let i = 0; i < primero.concepto_pago_id - 1; i++) {
                  let xcon = conceptos.find((c) => c.concepto_pago_id == i + 1);
                  let pago = {
                    concepto_pago_id: i + 1,
                    cantidad: 0,
                    monto: 0,
                    sub_total: 0,
                    concepto: xcon.concepto,
                  };
                  result[0].detalle.push(pago);
                }
              }
            }*/

            result.sort((a, b) => new Date(b.fecha_registro) - new Date(a.fecha_registro));

            result.forEach(function (p) {
              let pago = {};
              let importetotal = 0; 
              pago.id = p.id;
              // pago.fecha = vue.parsefecha(p.fecha_registro);
              pago.fecha = vue.parsefecha(p.fecha_registro);
              pago.recibo = vue.paddingceros(p.numero_recibo, 6);
              let fact_pad = vue.paddingceros(p.numero_factura, 7);
              //if (fact_pad == "0000000") fact_pad = "";
              pago.factura = fact_pad;
              pago.codigo_programa = p.codigo_programa;
              pago.estudiante = p.estudiante;
              pago.numero_documento_estudiante = p.numero_documento_estudiante;
              pago.tipoprograma = p.tipo_programa;
              pago.nombreprograma = p.nombre_programa;
              if (p.forma_pago_id == 1) pago.formapago = 'EFECTIVO';
              else if (p.forma_pago_id == 2) pago.formapago = 'TRANSFERENCIA';
              else if (p.forma_pago_id == 3) pago.formapago = 'TIGO MONEY';
              else if (p.forma_pago_id == 4) pago.formapago = 'MULTIPAGO';
              pago.banco = p.banco;
              pago.nrocuenta = p.numero_cuenta;
              pago.tipocuenta = p.tipo_cuenta;
              pago.depositante = p.nombre_depositante;
              pago.numero_comprobante = p.numero_comprobante;
              pago.numero_documento_depositante = p.numero_documento_depositante;
              pago.fechadelpago = vue.parsefecha(p.fecha_pago);
              pago.emisor = p.emisor;
              pago.asesor = p.asesor;

              pago.tramcertificacion = 0;
              pago.colegiatura = 0;
              pago.concepto = '?';
              pago.matricula = 0;
              pago.curso = 0;
              pago.otrosingresos = 0;

              p.detalle.sort((a, b) => {
                return a.concepto_pago_id - b.concepto_pago_id;
              });

              p.detalle.forEach(function (d) {
                if (vue.unidad_negocio == 1) {
                  if (p.nombre_programa.includes('Esam Cursos')) {
                    pago.curso += Number(d.monto);
                  } else if (d.concepto_pago_id == 3) {
                    pago.tramcertificacion += Number(d.monto);
                  } else if (pago.tipoprograma == 'Curso') {
                    pago.curso += Number(d.monto);
                  } else if (d.concepto_pago_id == 1) {
                    pago.matricula += Number(d.monto);
                  } else if (d.concepto.includes('Curso')) {
                    pago.curso += Number(d.monto);
                  } else if (d.concepto_pago_id == 2) {
                    pago.colegiatura += Number(d.monto);
                  } else if (d.opcional || d.concepto_pago_id == 19 || d.concepto_pago_id == 28) {
                    pago.otrosingresos += Number(d.monto) * Number(d.cantidad);
                  } else {
                    pago.otrosingresos += Number(d.monto) * Number(d.cantidad);
                    window.console.log('CONCEPTO DESCONOCIDO(agregado a otros ingresos)>', d);
                  }
                  importetotal =
                    pago.tramcertificacion + pago.matricula + pago.curso + pago.colegiatura + pago.otrosingresos;
                } else {
                  importetotal += Number(d.monto) * Number(d.cantidad);

                  let existe = vue.columnas_dinamicas.find((x) => {
                    let simulitud = similarity(x, d.concepto);
                    if (simulitud > 0.82) return x;
                    else return false;
                  });

                  if (!existe) { 
                    vue.columnas_dinamicas.push(d.concepto);
                    if (!pago[d.concepto]) pago[d.concepto] = 0;
                    pago[d.concepto] = parseFloat((pago[d.concepto] + Number(d.monto) * d.cantidad).toFixed(2));
                  } else {
                    if (!pago[existe]) pago[existe] = 0;
                    pago[existe] = parseFloat((pago[existe] + Number(d.monto) * d.cantidad).toFixed(2));
                  }
                  /*if (!existe) vue.columnas_dinamicas.push(d.concepto);
                                if (!pago[d.concepto]) pago[d.concepto] = 0;
                                pago[d.concepto] += d.monto;*/
                }
                pago.cantidad = d.cantidad;
                pago.xconcepto = d.concepto
                pago.concepto = vue.obtenerNumeroCuota(d.concepto);
              });
              pago.importetotal = vue.blankiscero(importetotal);
              pago.tramcertificacion = vue.blankiscero(pago.tramcertificacion);
              pago.colegiatura = vue.blankiscero(pago.colegiatura);
              pago.matricula = vue.blankiscero(pago.matricula);
              pago.curso = vue.blankiscero(pago.curso);
              pago.otrosingresos = vue.blankiscero(pago.otrosingresos);
              pago.estado = p.estado;
              // window.console.log('ppppppppppppppppp',p);
              vue.recibos.push(pago);
            });
          })
          .catch((e) => {
            vue.loading = false;
            window.console.log(e);
          });
      },
      getsimilaradd() {},
      filtrarsoloesam(result) {
        window.console.log('Filtrar las sedes ok...', result);
        result = result.filter((x) => {
          return x.sede_id != 10;
        });
        return result;
      },

      obtenerNumeroCuota(concepto_name){
        // window.console.log('concepto_name',concepto_name,'>',typeof(concepto_name),this.columnas_dinamicas);
        if(typeof(concepto_name) == 'object') {
          concepto_name = concepto_name.xconcepto
        }
        if(typeof(concepto_name) == 'object') return "-"
        
        const match = concepto_name.match(/-? ?(\d+)$/);
        let numero;
        if (match && match[1]) {
          numero = parseInt(match[1], 10); 
          return numero
        }
        return '?'
      }, 

      async getconceptospagos(idunidad) {
        if (!idunidad) {
          this.loading = false;
          return;
        }
        var vue = this;
        var sql = gql`query{ConceptoPagoAll(unidad_negocio_id:${idunidad}){id,nombre,monto,estado,facturable,opcional}}`;
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            let datos = data.data.ConceptoPagoAll;
            window.console.log(datos, vue.$store.state.CARGO.sede);
            vue.listarrecibos();
          })
          .catch((error) => {
            window.console.error(error);
          });
      },
      // buscar numeros de cuotas
      /* async listarInscripciones(inscripcion_id){

        try {
          const response = await xaxios.post(`${process.env.VUE_APP_API_REST}/api/pagos/recibos/buscar/inscripcion`, { inscripcion_id: inscripcion_id })
          // const result = await response.json()
          const data0 = response.data

          const res = {
            ciudades: data0,
          }
          window.console.log("resssss", res);
          
          return res
        } catch (e) {
          window.console.error('errorcillo:', e)
          throw e // O maneja el error de otra manera, por ejemplo, devolviendo null
        }

      } */
    },
    mounted() {
      this.isbenitojuarez = location.href.includes('recibosbenito');
      this.user = this.$store.state.DATA_USER;
      if (this.user.id == 31 || this.user.id == 1099 || this.user.id == 6457 || this.user.id == 1) {
        this.isnacional = true;
      }
      let hoy = new Date();
      let pasado = new Date();
      pasado.setDate(hoy.getDate() - 7); // 1 semana atras
      let d1 = hoy.getDate();
      let m1 = hoy.getMonth() + 1;
      let a1 = hoy.getFullYear();
      let d2 = pasado.getDate();
      let m2 = pasado.getMonth() + 1;
      let a2 = pasado.getFullYear();
      if (d1 < 10) d1 = '0' + d1;
      if (d2 < 10) d2 = '0' + d2;
      if (m1 < 10) m1 = '0' + m1;
      if (m2 < 10) m2 = '0' + m2;
      this.busqueda.fecha_ini = a2 + '-' + m2 + '-' + d2;
      this.busqueda.fecha_fin = a1 + '-' + m1 + '-' + d1;
      //this.listarrecibos();
      this.unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
      this.getconceptospagos(this.unidad_negocio);

      // window.console.log( '>>>',this.$store.state.CARGO );

      const getCellValue = (tr, idx) => tr.children[idx].innerText || tr.children[idx].textContent;
      const comparer = (idx, asc) => (a, b) =>
        ((v1, v2) => (v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2)))(
          getCellValue(asc ? a : b, idx),
          getCellValue(asc ? b : a, idx),
        );
      document.querySelectorAll('th').forEach((th) =>
        th.addEventListener('click', () => {
          const table = th.closest('table');
          const tbody = table.querySelector('tbody');
          Array.from(tbody.querySelectorAll('tr'))
            .sort(comparer(Array.from(th.parentNode.children).indexOf(th), (this.asc = !this.asc)))
            .forEach((tr, ind) => {
              tr.firstChild.innerHTML = ind + 1;
              tbody.appendChild(tr);
            });
        }),
      );
    },
  };
</script>

<style>
  .tabli tr:nth-child(even) {
    background: #d9e1f2;
  }
  .tabli tr:nth-child(odd) {
    background: #fff;
  }
  .tabli td,
  .tablii th {
    border-right: solid 1px #8ea9db;
  }
</style>
